export type ChangeType = 'feature' | 'improvement' | 'fix' | 'experiment';

export interface ChangelogEntry {
  version: string;
  type: ChangeType;
  title: string;
  description?: string;
}

/**
 * Changelog — история изменений, видимая пользователям.
 * Добавляйте новые записи в начало массива.
 * version — дата релиза (YYYY-MM-DD), используется для группировки.
 */
export const changelogEntries: ChangelogEntry[] = [
  // ── 2 ноября 2026 ───────────────────────────────────────────────
  {
    version: '2026-11-02',
    type: 'improvement',
    title: 'Регистрационная цена в «Корректировке цен»',
    description: 'В таблицах упаковок и граммов рядом со средней ценой по компании показана регистрационная цена с НДС. Она заполнена только у препаратов ЖНВЛП. По методологии 2027 эта цена важнее средней по компании, поэтому по ней видно, откуда берётся цена на этапах планирования.',
  },
  // ── 29 октября 2026 ─────────────────────────────────────────────
  {
    version: '2026-10-29',
    type: 'fix',
    title: 'Динамический план закупок до даты старта',
    description: 'До наступления даты старта планирования таблица «Динамический ПЗ» на этапе 2 плана закупок доступна только для просмотра — изменить и сохранить план нельзя.',
  },
  // ── 27 октября 2026 ─────────────────────────────────────────────
  {
    version: '2026-10-27',
    type: 'feature',
    title: 'Строка ИТОГО в «Сверке закупки»',
    description: 'В обеих вкладках экрана «Сверка закупки» внизу таблицы появилась строка ИТОГО по рублёвым колонкам. Она учитывает фильтры: суммируются только видимые строки. Таблица теперь показывается целиком, без разбивки на страницы.',
  },
  // ── 21 октября 2026 ─────────────────────────────────────────────
  {
    version: '2026-10-21',
    type: 'fix',
    title: 'Права на план закупок этапа 1',
    description: 'Сохранение плана закупок, плана по периодам и утверждение версии больше не требуют прав на план продаж — достаточно прав на закупки, выданных в администрировании.',
  },
  // ── 19 октября 2026 ─────────────────────────────────────────────
  {
    version: '2026-10-19',
    type: 'fix',
    title: 'Сохранение длинных SKU на этапе 3',
    description: 'Исправлена ошибка при сохранении распределения по БГ для SKU с длинным наименованием. История изменений таких ячеек сохраняется и открывается полностью.',
  },
  // ── 13 октября 2026 ─────────────────────────────────────────────
  {
    version: '2026-10-13',
    type: 'improvement',
    title: 'Описание методологий доступно всем',
    description: 'Значок ⓘ рядом с годом в шапке показывает, как считаются методологии 2026 и 2027, всем пользователям. Видеть и переключать саму методологию можно с правом, которое выдаёт администратор.',
  },
  {
    version: '2026-10-13',
    type: 'fix',
    title: 'Строка ИТОГО в сверке без дублей',
    description: 'В «Сверке ПП и ПЗ» строка ИТОГО больше не отображается дважды, если масштаб браузера или экрана отличается от 100%.',
  },
  // ── 12 октября 2026 ─────────────────────────────────────────────
  {
    version: '2026-10-12',
    type: 'feature',
    title: 'Два экрана в «Сверке ПП и ПЗ»',
    description: 'Сверка разделена на экраны «Сверка ПП и ПЗ» (выручка в ценах продаж, отклонение и итог) и «Сверка закупки»; доступ к каждому настраивается в админке.',
  },
  {
    version: '2026-10-12',
    type: 'improvement',
    title: 'Видимость методологии по ролям',
    description: 'Методология расчёта в шапке и в утверждённых версиях этапов 3 и 4 показывается только ролям, которым администратор выдал к ней доступ: с «Чтением» её видно, с «Редактированием» или «Полным доступом» можно переключать, при «Нет доступа» она скрыта.',
  },
  // ── 5 октября 2026 ──────────────────────────────────────────────
  {
    version: '2026-10-05',
    type: 'feature',
    title: 'Корректировка плана закупок по периодам',
    description: 'На вкладке «Периоды» этапа 2 плана закупок кнопка «Заполнить по периодам» раскладывает годовой план по месяцам, после чего значения по месяцам можно править вручную. Расхождения с годовым планом подсвечиваются красным, а утверждённая версия по-прежнему уходит в динамический план закупок.',
  },
  // ── 2 октября 2026 ──────────────────────────────────────────────
  {
    version: '2026-10-02',
    type: 'improvement',
    title: 'Новое письмо об изменении цен закупки',
    description: 'Письмо стало шире и компактнее: позиции сгруппированы по ЦПР, видны год планирования, было/стало и изменение в рублях и процентах.',
  },
  {
    version: '2026-10-02',
    type: 'improvement',
    title: 'Год планирования в журнале цен закупки',
    description: 'В «Почтовые уведомления» → «Цены закупки» добавлена колонка с годом, к которому относится изменённая цена.',
  },
  {
    version: '2026-10-02',
    type: 'fix',
    title: 'Удаление ручной цены в корректировке цен',
    description: 'В «Корректировке цен» теперь можно очистить цену ручного ввода — раньше сохранение пустой ячейки завершалось ошибкой сервера.',
  },
  // ── 30 сентября 2026 ────────────────────────────────────────────
  {
    version: '2026-09-30',
    type: 'feature',
    title: 'Сверка ПП и ПЗ по ЦПР в рублях',
    description: 'В «Сверке ПП и ПЗ» появилась аналитика по ЦПР в ценах закупки с НДС — одна строка на ЦПР с планом закупок, планом выручки и отклонением. Прежняя аналитика по ЦПР теперь называется «в единицах планирования».',
  },
  // ── 29 сентября 2026 ────────────────────────────────────────────
  {
    version: '2026-09-29',
    type: 'improvement',
    title: 'Старые вкладки плана закупок скрыты с 2027 года',
    description: 'Вкладки «Периоды 1.0» и «Динамический ПЗ 1.0» на первом этапе плана закупок остаются только для 2026 года.',
  },
  // ── 28 сентября 2026 ────────────────────────────────────────────
  {
    version: '2026-09-28',
    type: 'fix',
    title: 'Фильтр активных строк в планах по ТН-ЦПР',
    description: 'Переключатель «Все / Активные / Неактивные» в плане продаж (этап 2) и плане закупок (этап 1) снова показывает только выбранные строки.',
  },
  // ── 24 сентября 2026 ────────────────────────────────────────────
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Обновления в реальном времени не пропадают',
    description: 'Если вкладка открыта больше часа, изменения коллег продолжают приходить без обновления страницы.',
  },
  {
    version: '2026-09-24',
    type: 'improvement',
    title: 'Выбор года в шапке стал заметнее',
    description: 'Селектор года оформлен в цвет шапки и больше не выглядит неактивным.',
  },
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Индикатор соединения больше не краснеет зря',
    description: 'На страницах этапов снова видно, кто ещё работает на этапе, а изменения в Этапе 5 приходят без обновления страницы. Индикатор соединения в меню пользователя больше не показывает ошибку, когда связь в порядке.',
  },
  {
    version: '2026-09-24',
    type: 'feature',
    title: 'Уведомления об изменении цен закупки',
    description: 'После загрузки цен закупки система находит изменившиеся цены упаковок и граммов и отправляет одно письмо со сводкой выбранным адресатам. Настройки, ручная проверка и журнал изменений — во вкладке «Цены закупки» раздела «Почтовые уведомления».',
  },
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Разделы модуля видны на любом экране',
    description: 'Кнопки разделов (например, в «Управлении») подстраиваются под ширину экрана: длинные названия сокращаются, полное название видно при наведении.',
  },
  {
    version: '2026-09-24',
    type: 'feature',
    title: 'Настройка шаблонов писем',
    description: 'Администраторы могут редактировать тему и текст системных писем с переменными, смотреть предпросмотр, отправлять тестовое письмо и восстанавливать прежние версии. В журнале отправок появились статусы доставки по каждому адресу.',
  },
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Версии плана закупок по году планирования',
    description: 'В «Периодах» и «Динамическом ПЗ» показываются только утверждённые версии выбранного года, а утверждение фиксирует план только этого года.',
  },
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Удаление плана менеджеров при нулевом плане БГ',
    description: 'На этапе 4 теперь можно обнулить распределение по менеджерам, даже если план бизнес-группы равен нулю.',
  },
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Плановый объем выручки на этапе 2 по выбранному году',
    description: 'Быстрая аналитика этапа 2 показывала план этапа 1 за текущий год вместо выбранного года планирования.',
  },
  {
    version: '2026-09-24',
    type: 'fix',
    title: 'Заголовки месяцев в Динамическом ПЗ',
    description: 'Названия колонок в свёрнутых месяцах больше не сбиваются после обновления страницы и настроек.',
  },
  // ── 23 сентября 2026 ────────────────────────────────────────────
  {
    version: '2026-09-23',
    type: 'feature',
    title: 'Утверждение плана по МП в разрезе ЦПР-ТН-SKU',
    description: 'На вкладке «План продаж по БГ-ЦПР-ТН-МП» этапа 4 появилась кнопка «Утвердить»: она доступна, когда в «Быстрой аналитике по МП» нет отклонений, иначе выводится список менеджеров с суммами отклонений. Утверждённые версии можно просматривать и выгружать в Excel по значку версии справа от кнопки «Утвердить».',
  },
  {
    version: '2026-09-23',
    type: 'feature',
    title: 'План продаж и ТМЗ в плане закупок',
    description: 'В таблице 2s2d (этап 2 плана закупок) в каждом месяце появились колонки «Дин. Плановый объем выручки, ед. планирования» — план продаж по всем менеджерам и БГ за текущий и будущие месяцы — и «ТМЗ, ед. планирования на текущую дату» по отчёту «Товары на складах». Клик по плану продаж показывает, сколько приходится на каждую БГ.',
  },
  // ── 21 сентября 2026 ────────────────────────────────────────────
  {
    version: '2026-09-21',
    type: 'improvement',
    title: 'Утверждение этапа 3 по быстрой аналитике',
    description: 'План можно утвердить, когда в «Быстрой аналитике по БГ» нет отклонений. Отклонения по позициям ЦПР–ТН–SKU больше не блокируют утверждение: они выводятся списком с суммами, как и проблемные бизнес-группы.',
  },
  {
    version: '2026-09-21',
    type: 'improvement',
    title: 'Неактивные строки не блокируют утверждение этапа 3',
    description: 'При утверждении плана по ЦПР–ТН–SKU отклонения проверяются только по активным строкам. Неактивные строки по-прежнему сохраняются в утверждённой версии.',
  },
  // ── 7 сентября 2026 ─────────────────────────────────────────────
  {
    version: '2026-09-07',
    type: 'feature',
    title: 'Утверждение плана на этапе 3',
    description: 'План по ЦПР–ТН–SKU в разрезе БГ можно утвердить после устранения отклонений. Утверждённые версии сохраняются по годам, доступны для просмотра и выгрузки в Excel; право утверждения настраивается в ролях.',
  },
  {
    version: '2026-09-07',
    type: 'fix',
    title: 'Клиенты следуют выбранному году',
    description: 'В справочнике клиентов отображаются и сохраняются назначения менеджеров за выбранный год планирования. Данные и история изменений разных лет больше не смешиваются.',
  },
  // ── 2 сентября 2026 ─────────────────────────────────────────────
  {
    version: '2026-09-02',
    type: 'fix',
    title: 'Поставщик для нового ассортимента',
    description: 'Новым связкам ЦПР–ТН из раздела «1. КА» теперь автоматически назначается поставщик «Неизвестный партнер», поэтому они сразу корректно отображаются в разделе «5. Поставщики-КНП».',
  },
  {
    version: '2026-09-02',
    type: 'fix',
    title: 'Аналитика следует выбранному году',
    description: 'Аналитические таблицы теперь сопоставляют показатели выбранного года планирования с предыдущим годом. Заголовки обеих годовых колонок обновляются автоматически при переключении года.',
  },
  // ── 31 августа 2026 ─────────────────────────────────────────────
  {
    version: '2026-08-31',
    type: 'fix',
    title: 'Корректный год на этапе 4',
    description: 'Все представления, итоги и утверждённые версии этапа 4 теперь загружаются и сохраняются только для выбранного года.',
  },
  // ── 31 августа 2026 ─────────────────────────────────────────────
  {
    version: '2026-08-31',
    type: 'fix',
    title: 'Даты старта разделены по годам',
    description: 'В справочнике дат старта выбранный год теперь применяется к загрузке и сохранению, поэтому настройки разных лет больше не перезаписывают друг друга.',
  },
  // ── 27 августа 2026 ─────────────────────────────────────────────
  {
    version: '2026-08-27',
    type: 'feature',
    title: 'Переключение года планирования',
    description: 'Выбранный год теперь применяется к основным планам продаж и закупок, динамическим планам и сверкам; список годов будет автоматически расширяться.',
  },
  // ── 25 августа 2026 ──────────────────────────────────────────────────────
  {
    version: '2026-08-25',
    type: 'fix',
    title: 'Создание строк в пустой таблице справочника',
    description: 'Если за выбранный год планирования данных ещё нет, таблица больше не подменяется заглушкой: теперь видна шапка колонок и кнопка «Добавить строку», которой можно завести первую запись.',
  },
  // ── 10 августа 2026 ──────────────────────────────────────────────────────
  {
    version: '2026-08-10',
    type: 'improvement',
    title: 'Факт продаж и закупок в быстрой аналитике сверки ТМЗ',
    description: 'В сверке «ДПЗ и ДПП с учетом ТМЗ» карточка быстрой аналитики теперь показывает фактический объём выручки и закупок рядом с планами — отклонение ТМЗ можно проверить по всем шести показателям, в рублях и в единицах планирования.',
  },
  {
    version: '2026-08-10',
    type: 'improvement',
    title: 'Настройка заголовков сверки ДПЗ и ДПП с ТМЗ',
    description: 'Названия и цвета колонок этой сверки — и таблицы, и быстрой аналитики — теперь меняются в разделе «Администрирование → Настройки UI», без обращения к разработчикам.',
  },
  // ── 29 июля 2026 ─────────────────────────────────────────────────────────
  {
    version: '2026-07-29',
    type: 'fix',
    title: 'Сохранение любых месяцев в плане закупок по периодам',
    description: 'В «Плане закупок по периодам» (этап 2) корректировки количества теперь сохраняются для всех месяцев. Раньше правки месяцев, по которым ещё не было данных — чаще всего у позиций без SKU, — молча пропускались с предупреждением «Часть строк не найдена».',
  },
  // ── 27 июля 2026 ─────────────────────────────────────────────────────────
  {
    version: '2026-07-27',
    type: 'fix',
    title: 'Заявки в поддержку уходят по верному адресу',
    description: 'Исправлен адрес сервиса поддержки, а ссылка «Следить за заявками» после отправки теперь ведёт в тот же портал, куда попадает заявка.',
  },
  {
    version: '2026-07-27',
    type: 'fix',
    title: 'Строки не съезжают при свёрнутых месяцах',
    description: 'В динамическом плане продаж закреплённые слева колонки больше не смещаются по вертикали относительно остальной таблицы, когда месяцы свёрнуты.',
  },
  // ── 17 июля 2026 ─────────────────────────────────────────────────────────
  {
    version: '2026-07-17',
    type: 'fix',
    title: 'Ровные строки журнала почты',
    description: 'Значения в журнале почтовых уведомлений больше не переносятся на вторую строку.',
  },
  {
    version: '2026-07-17',
    type: 'feature',
    title: 'Контроль почтовых уведомлений',
    description: 'В админке появился раздел для проверки почтового сервиса, тестовой отправки и просмотра журнала системных писем.',
  },
  {
    version: '2026-07-17',
    type: 'fix',
    title: 'Строки динамического плана выровнены',
    description: 'Закреплённая и прокручиваемая части таблицы на этапе 5 остаются синхронными после масштабирования, сортировки, фильтрации и смены страницы.',
  },
  // ── 16 июля 2026 ─────────────────────────────────────────────────────────
  {
    version: '2026-07-16',
    type: 'feature',
    title: 'Уведомления об утверждении плана',
    description: 'После утверждения плана продаж на этапе 5 менеджеры бизнес-группы получают уведомление по электронной почте.',
  },
  {
    version: '2026-07-16',
    type: 'fix',
    title: 'Шапка адаптируется к масштабу',
    description: 'Навигация больше не перекрывает логотип и инструменты при уменьшении окна или увеличении масштаба страницы.',
  },
  // ── 15 июля 2026 ───────────────────────────────────────────
  {
    version: '2026-07-15',
    type: 'fix',
    title: 'Колонки быстрой аналитики выровнены',
    description: 'На этапе 5 в динамическом плане заголовки быстрой аналитики снова соответствуют данным, а ширина столбцов остаётся стабильной.',
  },
  {
    version: '2026-07-15',
    type: 'fix',
    title: 'Закрытые месяцы защищены от изменений',
    description: 'Динамический план продаж больше не отправляет данные в завершённые месяцы при сохранении других показателей; сервер также блокирует такие изменения.',
  },
  {
    version: '2026-07-15',
    type: 'fix',
    title: 'Утверждённый план показывает верную сумму',
    description: 'В сводке динамического плана на этапе 5 утверждённая выручка теперь соответствует выбранной утверждённой версии, а не текущему редактируемому плану.',
  },
  // ── 14 июля 2026 ───────────────────────────────────────────
  {
    version: '2026-07-14',
    type: 'fix',
    title: 'Сохранение ключевого ассортимента восстановлено',
    description: 'Новые строки ключевого ассортимента снова сохраняются без серверной ошибки, в том числе отдельно для выбранного года планирования.',
  },
  {
    version: '2026-07-14',
    type: 'fix',
    title: 'Исправлено сохранение динамического плана продаж',
    description: 'Устранена ошибка «Отсутствует обязательное поле» при вводе значений в новые месяцы на экране «Дин.план продаж от МП» (Этап 5).',
  },
  {
    version: '2026-07-14',
    type: 'fix',
    title: 'Надёжное сохранение планов продаж',
    description: 'Основной и динамический планы, а также КНР теперь сохраняются без сброса активных фильтров и лишней перезагрузки таблицы; повторное редактирование ячеек корректно учитывает сохранённые значения.',
  },
  // ── 9 июля 2026 ────────────────────────────────────────────
  {
    version: '2026-07-09',
    type: 'fix',
    title: 'Распределение плана больше не затирает чужие правки',
    description: 'При сохранении распределения по менеджерам (Этап 4 продаж) теперь записываются только изменённые строки — значения остальных менеджеров не перезаписываются.',
  },
  {
    version: '2026-07-09',
    type: 'improvement',
    title: 'Менеджеры в списках по алфавиту',
    description: 'Выпадающие списки и таблицы менеджеров на этапах 4 и 5 продаж теперь отсортированы по ФИО.',
  },
  // ── 8 июля 2026 ────────────────────────────────────────────
  {
    version: '2026-07-08',
    type: 'feature',
    title: 'Этап 4 продаж читает выбранный год планирования',
    description: 'Распределение плана по менеджерам, план по МП в разрезе БГ-ЦПР-ТН-SKU и мотивационный ПП теперь фильтруются и сохраняются по году, выбранному в шапке приложения.',
  },
  {
    version: '2026-07-08',
    type: 'improvement',
    title: 'Гибкая настройка права утверждения плана',
    description: 'Право утверждать план на этапах 4 и 5 продаж теперь выдаётся через роли в админке — например, менеджеру, замещающему руководителя БГ.',
  },
  // ── 6 июля 2026 ────────────────────────────────────────────
  {
    version: '2026-07-06',
    type: 'feature',
    title: 'История ячейки во всех таблицах планирования',
    description: 'Просмотр истории изменений теперь доступен в таблицах этапов 4 и 5 продаж, планирования закупок и справочников — правый клик → «История ячейки».',
  },
  {
    version: '2026-07-06',
    type: 'feature',
    title: 'История ячейки на этапе 3 продаж',
    description: 'В таблице распределения по БГ теперь можно посмотреть историю изменений любой редактируемой ячейки — правый клик → «История ячейки».',
  },
  // ── 3 июля 2026 ────────────────────────────────────────────
  {
    version: '2026-07-03',
    type: 'fix',
    title: 'Устранено зависание таблиц с изменениями',
    description: 'Таблицы с локальной панелью действий (отменить/повторить/сбросить) больше не могли аварийно перезагружаться при активных несохранённых изменениях.',
  },
  // ── 25 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-25',
    type: 'improvement',
    title: 'Пустое состояние таблиц при смене года',
    description: 'Таблицы в справочниках и этапе 1 продаж теперь отображают понятное сообщение «Нет данных за N год» вместо пустой сетки при отсутствии данных для выбранного года.',
  },
  {
    version: '2026-06-25',
    type: 'feature',
    title: 'Переключение года планирования',
    description: 'Единый выбор года в шапке управляет всеми таблицами планирования и справочников.',
  },
  // ── 19 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-19',
    type: 'fix',
    title: 'Корректный факт для рублёвых SKU в Динамическом ПЗ',
    description: 'В Динамическом плане закупок ЦПР-ТН-SKU для позиций с единицей планирования «руб.» «Факт закупки, ед.пл.» теперь совпадает с «Фактическим объёмом закупок, руб. с НДС».',
  },
  {
    version: '2026-06-19',
    type: 'fix',
    title: 'Сворачивание месяцев больше не «отваливается»',
    description: 'В динамических таблицах (Динамический план продаж и закупок ЦПР-ТН-SKU) свёрнутые через «Тонкую настройку месяцев» месяцы больше не разворачиваются обратно при обновлении данных.',
  },
  // ── 17 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-17',
    type: 'fix',
    title: 'Исправлено сохранение плана продаж и закупок ЦПР-ТН',
    description: 'На этапе 2 («Формирование плана продаж и закупок ЦПР-ТН-SKU») сохранение изменений больше не завершается ошибкой.',
  },
  // ── 15 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-15',
    type: 'improvement',
    title: 'Сводка по планированию в Быстрой аналитике',
    description: 'На странице динамического плана закупок (ЦПР-ТН-SKU) в блоке «Быстрая аналитика» теперь видны дата старта, утверждённая версия плана и кто её утвердил.',
  },
  {
    version: '2026-06-15',
    type: 'feature',
    title: 'Фильтр активных строк в Плане закупок ЦПР-ТН',
    description: 'На этапе «Формирование плана закупок ЦПР-ТН-SKU» появился фильтр «Строки: Все / Активные / Неактивные» — как на этапе 2. Неактивные позиции подсвечиваются серым.',
  },
  // ── 14 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-14',
    type: 'fix',
    title: 'Исправлено сохранение настроек интерфейса',
    description: 'В разделе «Конфигурация интерфейса» кнопка «Сохранить» больше не гаснет и не сбрасывает введённые значения, если в этот момент кто-то параллельно меняет настройки.',
  },
  {
    version: '2026-06-14',
    type: 'feature',
    title: 'Выбор отображаемых колонок в Динамическом ПЗ',
    description: 'В Плане закупок (Динамический) теперь можно индивидуально включать и выключать колонки между закреплённой областью и месяцами — как в Динамическом ПП. Выбор запоминается до следующего раза.',
  },
  // ── 12 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-12',
    type: 'improvement',
    title: 'Центр уведомлений временно скрыт',
    description: 'Колокольчик уведомлений убран из шапки на время доработки — он вернётся в обновлённом виде. Уведомления о результатах ваших действий (сохранение, ошибки) продолжают показываться как обычно.',
  },
  // ── 11 июня 2026 ───────────────────────────────────────────
  {
    version: '2026-06-11',
    type: 'fix',
    title: 'Надёжная подсветка изменений в таблицах',
    description: 'Подсветка изменённых ячеек теперь снимается после сохранения и сброса изменений, не смещается на соседние строки после добавления или удаления строк, а кнопка «Отменить изменения» корректно возвращает исходные значения при включённой сортировке и фильтрах.',
  },
  {
    version: '2026-06-11',
    type: 'fix',
    title: 'Убраны ложные пометки изменений после обновления страницы',
    description: 'После перезагрузки страницы таблицы больше не показывают подсветку изменений, которых на самом деле нет.',
  },
  // ── 21 мая 2026 ────────────────────────────────────────────
  {
    version: '2026-05-21',
    type: 'feature',
    title: 'Автор и дата изменения в ключевом ассортименте',
    description: 'В таблице «Ключевой ассортимент» добавлены колонки «Кто изменил» и «Дата изменения»; по умолчанию строки отсортированы от новых к старым. После добавления строки курсор сразу встаёт в неё, а после сохранения фокус переходит на сохранённую строку.',
  },
  {
    version: '2026-05-21',
    type: 'fix',
    title: 'Выпадающие списки в новой строке ассортимента',
    description: 'В таблице «Ключевой ассортимент» списки выбора ЦПР/ТН/ЕП теперь открываются заполненными, даже когда новая строка добавлена на отдельную страницу.',
  },
  {
    version: '2026-05-21',
    type: 'fix',
    title: 'Сохранение новых строк ключевого ассортимента',
    description: 'Добавленные строки в справочнике «Ключевой ассортимент» теперь корректно сохраняются — раньше новые записи молча терялись при сохранении.',
  },
  {
    version: '2026-05-21',
    type: 'fix',
    title: 'Стабильная работа таблицы ключевого ассортимента',
    description: 'При добавлении строки или редактировании ячейки таблица «Ключевой ассортимент» больше не перескакивает на первую страницу, а выпадающие списки выбора ЦПР/ТН/ЕП открываются без задержек.',
  },
  // ── 19 мая 2026 ────────────────────────────────────────────
  {
    version: '2026-05-19',
    type: 'fix',
    title: 'Верный «Утв.План в руб.» в быстрой аналитике',
    description: 'В быстрой аналитике динамического плана «Утв.План продаж от МП, в руб.» и «Отклонение Дин.Плана от Утв.Плана, в руб.» теперь показывают корректные значения во всех режимах, включая «Все БГ».',
  },
  {
    version: '2026-05-19',
    type: 'fix',
    title: 'Точный «Дин.План по клиенту» в карточке стратегических клиентов',
    description: 'В блоке «Стратегические клиенты» динамического плана «Дин.План по клиенту, руб.» теперь учитывает границу факт/план по выбранному году планирования (как в основной таблице) — для прошлых и будущих лет цифра и отклонение по клиенту больше не искажаются.',
  },
  // ── 18 мая 2026 ────────────────────────────────────────────
  {
    version: '2026-05-18',
    type: 'fix',
    title: 'Корректные итоги Утв.Плана в режиме «Все БГ»',
    description: 'В быстрой аналитике динамического плана для «Все БГ» столбцы «Утв.План продаж от МП, в руб.» и «Отклонение Дин.Плана от Утв.Плана, в руб.» теперь показывают реальные значения вместо прочерка, а итог «Утв.План в ед.план.» больше не завышается из-за помесячного дублирования.',
  },
  {
    version: '2026-05-18',
    type: 'fix',
    title: 'Совпадение итогов динамического плана в аналитике и Excel',
    description: 'В режиме «Все БГ» сумма в блоке быстрой аналитики («Дин.План в руб.») теперь совпадает с выгрузкой в Excel и итогом в таблице — раньше за уже прошедшие месяцы в аналитике учитывался план вместо факта, что давало расхождение в несколько млрд рублей.',
  },
  {
    version: '2026-05-18',
    type: 'feature',
    title: 'План по всем бизнес-группам',
    description: 'В динамическом плане продаж добавлена бизнес-группа «Все» — просмотр и редактирование плана сразу по всем подразделениям.',
  },
  // ── 13 мая 2026 ────────────────────────────────────────────
  {
    version: '2026-05-13',
    type: 'fix',
    title: 'Бейджи версий на этапах 4 и 5 корректно подстраиваются под светлую тему',
    description: 'Бейджи с номером утверждённой версии (Выручка / КНР / ВП KPI на этапе 4 и динамический план продаж на этапе 5) теперь читаемы в обеих темах: вместо ручной заливки используются цвета AntD-тегов, которые сами адаптируются к светлой и тёмной теме.',
  },
  {
    version: '2026-05-13',
    type: 'improvement',
    title: 'ЦПР всегда отсортированы единым правилом: латиница, потом кириллица',
    description: 'Во всех представлениях этапов 1–5, в сверке и в справочниках ЦПР упорядочены сначала по латинскому алфавиту, затем по кириллическому. Порядок согласован между бэком и фронтом — пересортировка после загрузки больше не «перекидывает» латиницу в конец.',
  },
  {
    version: '2026-05-13',
    type: 'improvement',
    title: 'Менеджеры в плане продаж этапа 4 отсортированы по алфавиту',
    description: 'В представлении «План продаж» все три таблицы (выручка, КНР, ВП KPI) показывают менеджеров в едином алфавитном порядке по ФИО.',
  },
  {
    version: '2026-05-13',
    type: 'improvement',
    title: 'В «Быстрой аналитике по МП» учитываем статус сотрудников',
    description: 'Менеджеры, уволенные в прошлые годы, больше не приезжают в распределение и аналитику — отсечены на уровне базы. Уволенные в этом году подсвечены серым, новые сотрудники (< 3 месяцев) — зелёным; цвета те же, что в остальных представлениях этапа 4.',
  },
  {
    version: '2026-05-13',
    type: 'fix',
    title: 'Подсветка неактивных строк и отклонений снова корректна при фильтрах',
    description: 'При использовании фильтров Handsontable серый фон неактивных строк и красно-зелёная заливка отклонений уезжали на чужие строки — теперь подсветка всегда соответствует видимым данным.',
  },
  // ── 12 мая 2026 ────────────────────────────────────────────
  {
    version: '2026-05-12',
    type: 'feature',
    title: 'Руководитель БГ может отметить «Готово» за менеджера',
    description: 'На странице «Динамический план продаж» руководитель бизнес-группы теперь может зафиксировать ежемесячную актуализацию за менеджера своей БГ — например, если тот в командировке, отпуске или на больничном.',
  },
  {
    version: '2026-05-12',
    type: 'feature',
    title: 'Фильтр активных и неактивных строк в плане продаж',
    description: 'На этапах 2, 3 и 5 плана продаж, а также в таблице «Распределение по МП в разрезе SKU» этапа 4, появился переключатель «Все / Активные / Неактивные». Неактивные строки теперь видны и выделены серым; редактировать их нельзя.',
  },
  // ── 7 мая 2026 ─────────────────────────────────────────────
  {
    version: '2026-05-07',
    type: 'fix',
    title: 'Заголовки таблиц этапа 1 теперь редактируются из админки',
    description: 'Наборы заголовков «Планирование», «КНР», «Аналитика бизнес-групп», «Периоды закупок» и «План по ЦПР» теперь подтягиваются из настроек интерфейса и доступны для редактирования в админ-панели.',
  },
  // ── 5 мая 2026 ─────────────────────────────────────────────
  {
    version: '2026-05-05',
    type: 'fix',
    title: 'Дедлайн актуализации можно выбрать только в пределах своего месяца',
    description: 'В таблице дедлайнов модуля «Актуализация» календарь теперь открывается и ограничивается месяцем строки: для строки «Май» можно поставить только майскую дату. Ручной ввод за пределами месяца отклоняется при сохранении.',
  },
  {
    version: '2026-05-05',
    type: 'feature',
    title: 'Фильтр «Работают / Уволены / Все» в таблице актуализации',
    description: 'Над таблицей менеджеров появился переключатель: «Работают» (по умолчанию), «Уволены» (только серые строки) и «Все». В каждой подписи рядом — количество. Сводка «Всего / Готово» над месяцами пересчитывается под выбранную выборку.',
  },
  {
    version: '2026-05-05',
    type: 'feature',
    title: 'Сводка «Всего / Готово» над каждым месяцем в модуле актуализации',
    description: 'В модуле «Актуализация» над каждым месячным столбцом сразу видно «Всего: N» и «Готово: K/N» — ответ для руководства за секунду по любому месяцу, а не только по текущему. Также добавлен процент готовности рядом со сводкой текущего месяца.',
  },
  {
    version: '2026-05-05',
    type: 'improvement',
    title: 'Кнопка «Готово» в Динамическом плане — только для конкретного менеджера',
    description: 'При выбранном фильтре «Все менеджеры» кнопка «Готово» теперь неактивна. Менеджер и РБГ жмут «Готово» за себя, а администратор может зафиксировать актуализацию за выбранного менеджера — отметка в учёте сохраняется именно за этим менеджером.',
  },
  // ── 3 мая 2026 ─────────────────────────────────────────────
  {
    version: '2026-05-03',
    type: 'improvement',
    title: 'Динамический план открывается с фильтрами «Только с данными» и «Активные»',
    description: 'По умолчанию таблица сразу показывает строки с данными по активным позициям — меньше шума на старте. Переключатели остаются доступны и запоминают ваш выбор.',
  },
  {
    version: '2026-05-03',
    type: 'feature',
    title: 'Актуализация динамического плана',
    description: 'В разделе «Управление» появился восьмой модуль: ФАО задаёт дедлайны актуализации по месяцам, а в Динамическом плане у менеджеров видна дата актуализации, дата последнего апдейта и кнопка «Готово». В аналитике модуля видно, кто и когда подтвердил актуализацию, с фильтром по бизнес-группе.',
  },
  // ── 28 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-28',
    type: 'feature',
    title: 'Тур-онбординг по демо-таблице на главной',
    description: 'При первом просмотре демо «Динамический план продаж» открывается короткий тур из 4 шагов с анимациями: изменение ширины столбцов, редактирование ячеек, фильтры и сворачивание месяцев. Запустить повторно можно кнопкой «Показать подсказки».',
  },
  {
    version: '2026-04-28',
    type: 'improvement',
    title: 'Главная сразу показывает ключевые тезисы',
    description: 'Кнопка «Узнать больше» из героя убрана — раздел «Прозрачность процесса и сохранность данных» виден без дополнительного скролла.',
  },
  // ── 27 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'План продаж от РБГ на этапе 5 берётся из утверждённой версии',
    description: 'В карточке «ИТОГО» этапа «План продаж по МП» значение «План продаж от РБГ, выручка по МП, руб.» теперь читается из последней утверждённой версии плана продаж, а не из черновика.',
  },
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'Быстрая аналитика по МП использует утверждённый план продаж',
    description: 'В блоке «Быстрая аналитика по МП» (этап 4 → Распределение по МП) колонка «План продаж по МП, руб» теперь берётся из последней утверждённой версии плана, а не из черновика.',
  },
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'Динамический план продаж: для прошедших месяцев в свёрнутом виде показывается факт',
    description: 'У уже завершённых месяцев колонки «Факт продаж» и «Кол-во к продаже» меняются местами. В свёрнутом виде менеджер сразу видит реальный факт, а не плановое значение. Расчёты не меняются.',
  },
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'Динамический план продаж: шапка не уезжает при прокрутке',
    description: 'При выборе 65 и более строк на странице шапка таблицы остаётся на месте — теперь видно, к какой колонке относится значение.',
  },
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'Этап 5: проверка отклонений перед утверждением плана продаж',
    description: 'Кнопка «Утвердить план» теперь блокируется, пока есть отклонение между планом РБГ и распределением МП. В подсказке указана сумма отклонения.',
  },
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'Экспорт в Excel: стили, цвета шапки, форматы чисел и автофильтр',
    description: 'Шапка в Excel теперь повторяет цвета из настроек интерфейса, числа экспортируются с форматом из таблицы (тысячи, проценты, валюта), добавлены жирные заголовки, бордеры и фильтр Excel.',
  },
  {
    version: '2026-04-27',
    type: 'fix',
    title: 'Экспорт в Excel со сгруппированными колонками',
    description: 'Шапка с многоуровневыми заголовками теперь корректно выгружается, когда часть колонок скрыта — заголовки и объединения совпадают со столбцами данных.',
  },
  {
    version: '2026-04-27',
    type: 'fix',
    title: 'Динамический план продаж: пустой SKU вместо placeholder',
    description: 'Строки с техническим SKU (00000000-…) больше не показывают этот идентификатор в колонке SKU.',
  },
  {
    version: '2026-04-27',
    type: 'fix',
    title: 'Поиск в фильтрах на снепшотах планов',
    description: 'В окнах «Утверждённые версии» (продажи, закупки) снова работает ввод в поле поиска значений фильтра.',
  },
  {
    version: '2026-04-27',
    type: 'fix',
    title: 'Справочник «Клиенты»: корректное сохранение БГ',
    description: 'При выборе менеджера БГ теперь подставляется автоматически и сохраняется без перепутывания между БГ.',
  },
  {
    version: '2026-04-27',
    type: 'improvement',
    title: 'Справочник «Клиенты»: упрощён ввод новой строки',
    description: 'Поля БГ и Менеджер можно заполнять в любом порядке — БГ автоматически подтянется по выбранному менеджеру.',
  },

  // ── 23 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-23',
    type: 'fix',
    title: 'Заявки в поддержку создаются от имени текущего пользователя',
    description: 'Исправлена ситуация, когда при нескольких учётных записях в браузере заявка в поддержку могла быть создана от имени другого пользователя.',
  },

  // ── 17 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-17',
    type: 'improvement',
    title: 'Сообщение об успешном сохранении появляется после сброса подсветки',
    description: 'В динамическом плане продаж тост «Данные сохранены» теперь показывается после того, как с изменённых ячеек снята жёлтая подсветка — чтобы сначала было видно «чистую» таблицу, а потом подтверждение.',
  },
  {
    version: '2026-04-17',
    type: 'fix',
    title: 'Сводка динамического плана продаж уважает активные фильтры после сохранения',
    description: 'После сохранения изменений сводка больше не «слетает» на суммы по всей таблице, если в заголовках применены фильтры. Значения пересчитываются с учётом текущих видимых строк.',
  },
  // ── 15 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-15',
    type: 'fix',
    title: 'Корректные цвета отклонений при фильтрации в динамическом плане',
    description: 'В таблице динамического плана продаж после применения фильтра в шапке отрицательные отклонения снова подсвечиваются красным, а положительные — зелёным.',
  },
  // ── 14 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-14',
    type: 'fix',
    title: 'Менеджерам вернули переключатель «Только с данными» на этапе 5',
    description: 'Раньше фильтр был скрыт вместе с выбором бизнес-группы и менеджера, недоступным для роли «Менеджер». Теперь переключатель отображается всегда.',
  },
  {
    version: '2026-04-14',
    type: 'fix',
    title: 'Кнопка «Сбросить настройки колонок» появляется сразу после ресайза',
    description: 'Раньше кнопка сброса ширины колонок показывалась только после перезагрузки страницы. Теперь она появляется сразу, как только вы измените ширину любой колонки.',
  },
  {
    version: '2026-04-14',
    type: 'improvement',
    title: 'Тонкая настройка сворачивания месяцев в динамическом плане продаж',
    description: 'Кнопка управления месяцами в тулбаре таблицы превратилась в split-button с меню: свернуть/развернуть все, свернуть прошедшие месяцы, оставить только текущий квартал, а также индивидуальные чекбоксы по каждому месяцу. Выбранное состояние запоминается — при следующем открытии страницы месяцы останутся свёрнутыми.',
  },
  {
    version: '2026-04-14',
    type: 'improvement',
    title: 'Увеличен фильтр по значениям в шапке таблиц',
    description: 'Окно фильтра колонки и список значений стали заметно шире и выше, длинные названия (SKU, бизнес-группы, контрагенты) больше не обрезаются и видны целиком.',
  },

  // ── 13 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-13',
    type: 'improvement',
    title: 'Убран лишний перезапрос данных после собственного сохранения',
    description: 'Раньше после нажатия «Сохранить» таблица грузилась дважды и на тяжёлых страницах (например, динамический план продаж) первый запрос успевал отмениться с ошибкой. Теперь обновление подтягивается одним запросом сразу после сохранения.',
  },
  {
    version: '2026-04-13',
    type: 'fix',
    title: 'Устранена ошибка «Запрос был отменен» в динамическом плане продаж',
    description: 'На 5 этапе при выборе бизнес-группы или бизнес-группы с менеджером страница больше не падает из-за гонки загрузки — запрос стартует только после выбора БГ, а отменённые фоновые обращения не показываются как ошибка.',
  },
  {
    version: '2026-04-13',
    type: 'improvement',
    title: 'Ускорено сохранение больших корректировок на 5 этапе',
    description: 'Массовое сохранение планов, % КНР и динамического плана теперь выполняется одним запросом в базу вместо построчных — крупные правки проходят в разы быстрее.',
  },
  // ── 12 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-12',
    type: 'fix',
    title: 'Корректный пересчёт и отмена в динамическом плане продаж',
    description: 'На 5 этапе при правке количества и % КНР пересчёт зависимых ячеек теперь попадает в историю изменений — Ctrl+Z корректно возвращает строку в исходное состояние.',
  },
  {
    version: '2026-04-12',
    type: 'improvement',
    title: 'Быстрое переключение менеджера и БГ на 5 этапе',
    description: 'При смене бизнес-группы или менеджера предыдущий тяжёлый запрос теперь отменяется сразу — новые данные загружаются быстрее, а нагрузка на сервер ниже.',
  },
  // ── 11 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-11',
    type: 'feature',
    title: 'Тёмная тема оформления',
    description: 'Переключайте между светлой и тёмной темой через иконку в шапке или в настройках профиля. Можно выбрать автоматический режим — тема подстроится под настройки вашей ОС.',
  },
  // ── 10 апреля 2026 ─────────────────────────────────────────
  {
    version: '2026-04-10',
    type: 'fix',
    title: 'Исправлены названия колонок в таблицах периодов и динамического плана',
    description: 'Колонки месяцев больше не отображаются как буквы A, B, C вместо названий.',
  },
  {
    version: '2026-04-10',
    type: 'fix',
    title: 'Исправлены заголовки свёрнутых месяцев после сохранения',
    description: 'В динамическом плане продаж (Этап 5) при сохранении данных с активными фильтрами заголовки свёрнутых месяцев больше не теряют названия.',
  },
  // ── 1 апреля 2026 ──────────────────────────────────────────
  {
    version: '2026-04-01',
    type: 'improvement',
    title: 'Ускорена синхронизация данных на Этапе 5',
    description: 'Уведомления об изменениях теперь приходят только пользователям, работающим с той же бизнес-группой. Снижена нагрузка при одновременной работе многих пользователей.',
  },
  // ── 30 марта 2026 ──────────────────────────────────────────
  {
    version: '2026-03-30',
    type: 'feature',
    title: 'Страница авторизации',
    description: 'Новая брендированная страница входа в систему с логотипом, описанием платформы и кнопкой входа через Microsoft.',
  },
  // ── 29 марта 2026 ──────────────────────────────────────────
  {
    version: '2026-03-29',
    type: 'feature',
    title: 'Обновлён динамический план продаж менеджеров',
    description: 'Новая структура колонок (89 колонок), расчётные формулы выручки, быстрая аналитика по стратегическим клиентам, сводка в виде таблицы.',
  },
  {
    version: '2026-03-29',
    type: 'improvement',
    title: 'Блокировка интерфейса при смене фильтров',
    description: 'Селекторы бизнес-группы и менеджера блокируются до завершения загрузки данных динамического плана.',
  },
  // ── 21 марта 2026 ──────────────────────────────────────────
  {
    version: '2026-03-21',
    type: 'improvement',
    title: 'Улучшен интерфейс настройки UI-конфигурации',
    description: 'Группировка секций в боковой панели, индикаторы изменений, отслеживание несохранённых правок и миниатюры цветов в заголовках.',
  },
  {
    version: '2026-03-21',
    type: 'improvement',
    title: 'Настраиваемые заголовки колонок во всех таблицах',
    description: 'Заголовки колонок всех таблиц теперь можно менять через UI Config — администраторы могут переименовывать колонки без изменения кода.',
  },
  {
    version: '2026-03-21',
    type: 'improvement',
    title: 'Настраиваемые названия разделов и этапов',
    description: 'Названия пунктов навигации, заголовки этапов и представлений теперь можно менять через конфигуратор интерфейса.',
  },
  // ── 20 марта 2026 ──────────────────────────────────────────
  {
    version: '2026-03-20',
    type: 'feature',
    title: 'Конфигуратор интерфейса в панели администратора',
    description: 'Настройка цветов отклонений, заголовков таблиц и текстов кнопок для всех разделов. Превью изменений и история с откатом.',
  },
  // ── 17 марта 2026 ──────────────────────────────────────────
  {
    version: '2026-03-17',
    type: 'feature',
    title: 'Сверка: колонка отклонения в ценах закупки',
    description: 'В таблицу сверки добавлен столбец «Отклонение, в ценах закупки, руб. с НДС».',
  },
  {
    version: '2026-03-17',
    type: 'fix',
    title: 'Исправлено сохранение в справочнике отгрузки',
    description: 'При сохранении одной ячейки теперь отправляется только изменённая запись, а не все 12 месяцев сразу.',
  },
  // ── 12 марта 2026 ──────────────────────────────────────────
  {
    version: '2026-03-12',
    type: 'feature',
    title: 'Новый модуль «Сверка»',
    description: 'Сверка плана продаж и плана закупок в разрезе ЦПР-ТН-SKU, контроль остатков по году и по месяцам.',
  },

  // ── 9 марта 2026 ───────────────────────────────────────────
  {
    version: '2026-03-09',
    type: 'improvement',
    title: 'Переработка экрана «План продаж» (этап 5)',
    description: 'Плоская таблица вместо месячной разбивки, блок стратегических клиентов, динамический пересчёт ИТОГО по фильтрам и новый таб «Периоды».',
  },
  {
    version: '2026-03-09',
    type: 'feature',
    title: '% распределения планов по периодам — новая таблица и комментарии',
    description: 'Добавлена вторая таблица «по компании», колонка ИТОГО, а также возможность оставлять комментарии к модулям и таблицам из админки.',
  },

  // ── 25 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-25',
    type: 'improvement',
    title: 'Создание заявки прямо из экрана ошибки',
    description: 'При любой ошибке теперь можно одним кликом создать заявку в поддержку — тема и описание заполнятся автоматически.',
  },

  // ── 23 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-23',
    type: 'feature',
    title: 'Заявка в поддержку прямо из приложения',
    description: 'Теперь по кнопке поддержки в шапке открывается форма для создания обращения — без перехода на внешний сайт.',
  },
  {
    version: '2026-02-23',
    type: 'improvement',
    title: 'Улучшена производительность 5-го этапа',
    description: 'Устранён чрезмерный опрос дочерних таблиц, исправлена блокировка редактирования в динамическом плане.',
  },
  {
    version: '2026-02-23',
    type: 'feature',
    title: 'Динамический план продаж',
    description: 'Новый экран «Динамический ПП» на 5-м этапе: утверждение версий плана, блокировка форм по дате старта и таблица динамического планирования.',
  },
  // ── 21 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-21',
    type: 'improvement',
    title: 'Присутствие на этапе перенесено в шапку',
    description: 'Аватары коллег на этапе теперь отображаются в основной шапке рядом с кнопкой обновления — всегда на виду.',
  },
  {
    version: '2026-02-21',
    type: 'feature',
    title: '«Что нового?»',
    description: 'Теперь вы всегда можете узнать о последних обновлениях системы прямо из шапки приложения.',
  },
  {
    version: '2026-02-21',
    type: 'improvement',
    title: 'Индикатор соединения перенесён на аватар',
    description: 'Статус WebSocket-подключения теперь отображается точкой на аватаре — как в привычных мессенджерах.',
  },

  // ── 20 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-20',
    type: 'improvement',
    title: 'Обновление TrackedTable',
    description: 'Улучшена стабильность и производительность таблиц с отслеживанием изменений.',
  },

  // ── 18 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-18',
    type: 'improvement',
    title: 'Обновление справочников',
    description: 'Таблицы справочников переведены на унифицированную архитектуру (hooks + constants). Улучшена скорость загрузки и сохранения.',
  },

  // ── 17 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-17',
    type: 'feature',
    title: 'Присутствие на этапах (Stage Presence)',
    description: 'Теперь видно, кто из коллег сейчас работает на том же этапе планирования. Аватары отображаются в подшапке.',
  },
  {
    version: '2026-02-17',
    type: 'feature',
    title: 'Real-time обновления',
    description: 'Данные в таблицах обновляются в реальном времени через WebSocket — без перезагрузки страницы.',
  },
  {
    version: '2026-02-17',
    type: 'improvement',
    title: 'Кэширование и персистенция',
    description: 'Критичные данные (RBAC, feature-flags) кэшируются в IndexedDB для мгновенного первого рендера.',
  },

  // ── 11 февраля 2026 ────────────────────────────────────────
  {
    version: '2026-02-11',
    type: 'feature',
    title: 'Новый модуль закупок',
    description: 'Добавлен модуль планирования закупок с динамическими планами, аналитикой и периодами.',
  },
  {
    version: '2026-02-11',
    type: 'feature',
    title: 'Режим Canvas',
    description: 'Визуализация таблиц в виде интерактивных узлов на холсте (бета). Переключение между Stack/Canvas в настройках.',
  },
  {
    version: '2026-02-11',
    type: 'improvement',
    title: 'Рефакторинг этапов продаж',
    description: 'Этапы 1–5 переведены на трёхслойную архитектуру (Data → Computed → Actions). Стабильнее, быстрее, проще поддерживать.',
  },
];
